import { map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { BuildingSpaceType } from '../../model/building-space-type';

@Injectable()
export class BuildingSpaceTypeService extends DataService<BuildingSpaceType> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, BuildingSpaceType, progressBar, 'building-space-type');
  }

  protected createModel(modelData: any): BuildingSpaceType {
    try {
      return new BuildingSpaceType(modelData);
    } catch (e) {
      console.log(e);
      throw new Error('Invalid data format.');
    }
  }

  add(model: BuildingSpaceType, options: { notifyUser: boolean } = { notifyUser: true }) {
    return super.add(model, options).pipe(map(s => s.id));
  }
}
